module.exports = 'react-ansi-style-';



//////////////////
// WEBPACK FOOTER
// /Users/remi/Documents/metabase/metabase-0.28.1/node_modules/react-ansi-style/default-css-prefix.js
// module id = 1104
// module chunks = 7